import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UiState {
  sidebarOpen: boolean;
  globalSearchOpen: boolean;
  toast?: { message: string; severity: 'success' | 'error' | 'info' | 'warning' };
}

const initialState: UiState = {
  sidebarOpen: true,
  globalSearchOpen: false,
};

const slice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar(state) {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebar(state, action: PayloadAction<boolean>) {
      state.sidebarOpen = action.payload;
    },
    setGlobalSearch(state, action: PayloadAction<boolean>) {
      state.globalSearchOpen = action.payload;
    },
    showToast(state, action: PayloadAction<UiState['toast']>) {
      state.toast = action.payload;
    },
    clearToast(state) {
      state.toast = undefined;
    },
  },
});

export const { toggleSidebar, setSidebar, setGlobalSearch, showToast, clearToast } =
  slice.actions;
export default slice.reducer;
